import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  planogramName: "",
  planogramNumber: "",
  planogram: "",
  department: "",
  category: "",
  plannerNotes: "",
  retailerNotes: "",
  skus: null,
  lf: null,
  adjLf: null,
  core: "",
  region: "",
  selected: "",
  poNumber: "",
  releaseStatus: "",
  releaseDate: null,
  missing: null,
  qty: null,
  adjQty: null,
  cost: null,
  extCost: null,
  adjCost: null,
  qtyMultiplier: null,
  coreDiscount: null,
  nonCoreDiscount: null,
  discMultplier: null,
  datingDays: null,
};

export const itemPogSummarySlice = createSlice({
  name: "itemPogSummary",
  initialState,
  reducers: {
    setDepartmentName: (state, { payload = 0 }) => {
      state.department = payload;
    },
    setItemPogSummaryDetails: (state, { payload }) => {
      state.planogramName = payload?.PlanogramName;
      state.planogramNumber = payload?.PlanogramNumber;
      state.planogram = payload?.PlanogramPDF;
      state.department = payload?.DepartmentName;
      state.departmentLetter = payload?.DepartmentLetter;
      state.category = payload?.Category;
      state.plannerNotes = payload?.PlannerNotes;
      state.retailerNotes = payload?.RetailerNotes;
      state.skus = payload?.SKUs;
      state.lf = payload?.LinealFootage;
      state.adjLf = payload?.AdjLineal;
      state.core = payload?.Core;
      state.region = payload?.Region;
      state.urbanicity = payload?.Urbanicity;
      state.selected = payload?.Selected;
      state.poNumber = payload?.PONumber;
      state.releaseStatus = payload?.ReleaseStatus;
      state.releaseDate = payload?.ReleaseDate;
      state.missing = payload?.MissingSkus;
      state.qty = payload?.Qty;
      state.adjQty = payload?.AdjQty;
      state.cost = payload?.Cost;
      state.extCost = payload?.ExtCost;
      state.adjCost = payload?.AdjCost;
      state.qtyMultiplier = payload?.QtyMultiplier;
      state.coreDiscount = payload?.CoreDiscount;
      state.nonCoreDiscount = payload?.NonCoreDiscount;
      state.discMultiplier = payload?.DiscMultiplier;
      state.datingDays = payload?.DatingDays;
      state.allItemsFromFillIn = payload?.AllItemsFromFillIn;
    },
  },
});

export const { setItemPogSummaryDetails, setDepartmentName } =
  itemPogSummarySlice.actions;

export default itemPogSummarySlice.reducer;
